import { useState, useEffect } from "react";
import axios from "axios";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { useNavigate } from "react-router-dom";
import DeletePendingProductModal from "../modals/DeletePendingProductModal";
import PendingProductAccessModal from "../modals/PendingProductAccessModal";



export default function OnePendingProduct({pendingProdId,changeView,selectProduct}) {


 
   
 

  const [product, setProduct] = useState([]);

  const [loading, setLoading] = useState(true);
  const { user, dispatch } = useAuthContext();

  const [activeModal, setActiveModal] = useState(false);

  const [addEventModal, setAddEventModal] = useState(false);
  const [addedEvents, setAddedEvents] = useState([]);
  const [deleteProdModal, setDeleteProdModal] = useState(false);
  const navi = useNavigate()



  const fetchData = async () => {
    setLoading(true);
    try {
      const addedEventsResponse = await axios.get(
        `${ApiConnectionString}/api/pendingEvent/curentAccess/${pendingProdId}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (addedEventsResponse.status === 200) {
        setAddedEvents(addedEventsResponse.data);
      }

      const prodResponse = await axios.get(
        `${ApiConnectionString}/api/PendingProduct/${pendingProdId}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      setProduct(prodResponse.data);

      setLoading(false);
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error("Error fetching data:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }

    return () => clearTimeout(timeout); // Cleanup timeout on re-run
  }, [user]);

  const cancelModal = () => {
    setActiveModal(false);
    setAddEventModal(false);
    setDeleteProdModal(false);
  };

  if (loading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div className="container">
      <div className="bg-white mx-5 my-2 p-0 ">
        <div className="blueBanner">
          <p className="text-white p-3 mx-3 my-0 fw-bold fontSize20 ">
            Product : {product.name}
          </p>
        </div>
        <div className="d-flex justify-content-end">
          {!product.totalAccess && (
            <button onClick={() => {setAddEventModal(true)}} className="settings-menu-button">
              Add or Remove event access
            </button>
          )}
          <button onClick={() => {selectProduct(pendingProdId,"updateProduct")}} className="settings-menu-button">
            Edit
          </button>
          <button onClick={() => {setDeleteProdModal(true)}} className="settings-menu-button">
            Delete
          </button>
          <button onClick={() => {changeView("mainPage")}} className="settings-menu-button">
            Go Back
          </button>
        </div>

        <table className="mx-2">
          <tbody>
            <tr>
              <th className="red-text">Club:</th>
              <td>{product.clubName}</td>
            </tr>
            <tr>
              <th className="red-text">Product Name:</th>
              <td>{product.name}</td>
            </tr>
            <tr>
              <th className="red-text">Description:</th>
              <td>{product.description}</td>
            </tr>

          
            <tr>
              <th className="red-text">Type:</th>
              {product.recurring ? (
                <td>Subscription</td>
              ) : (
                <td>Pay-as-you-go</td>
              )}
            </tr>
            {product.recurring && (
              <tr>
                <th className="red-text">Interval:</th>
                <td>{product.interval}</td>
              </tr>
            )}
            <tr>
              <th className="red-text">Cost:</th>
              <td>£{product.price / 100}</td>
            </tr>
            {product.token > 0 && (
              <tr>
                <th className="red-text">Classes</th>
                <td>{product.token}</td>
              </tr>
            )}
          </tbody>
        </table>

        {!product.totalAccess ? (
          <div>
            {" "}
            <div className="lightBlueBanner">
              <p className="mb-0 mt-3 p-2">
                This product allows access to the classes listed below.
              </p>
            </div>
            <table className="custom-table mt-0">
              <thead className="blueBanner">
                <tr>
                  <th>Class</th>
                  <th>Day</th>
                  <th>Times</th>
                </tr>
              </thead>
              <tbody>
                {addedEvents.map((event) => (
                  <tr key={event.id}>
                    <td>{event.name}</td>
                    <td>{event.day}</td>
                    <td>
                      {event.timeIn} - {event.timeOut}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>{" "}
          </div>
        ) : (
          <p>
            This product allows access to all classes.
          </p>
        )}
      </div>


      {deleteProdModal && <DeletePendingProductModal cancelModal={cancelModal} product={product} changeView={changeView} />}

{addEventModal && <PendingProductAccessModal     cancelModal={cancelModal}
          productId={product.id}
          clubId={product.pendingClubId}/>}
      {/* {addEventModal && (
        <AddEventAccess
          cancelModal={cancelModal}
          productId={id}
          clubId={product.clubId}
        />
      )}
      {deleteProdModal && (
        <DeleteProductModal cancelModal={cancelModal} product={product} />
      )} */}
    </div>
  );
}
